import axios from 'axios'
axios.defaults.withCredentials = true
export function createAPI (config) {
  return axios.create(config)
}
